var React = require('react');

function IconActivity (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.1,10 L20.9,10 C21.5075132,10 22,10.4477153 22,11 C22,11.5522847 21.5075132,12 20.9,12 L1.1,12 C0.492486775,12 0,11.5522847 0,11 C0,10.4477153 0.492486775,10 1.1,10 Z M1.1,3 L20.9,3 C21.5075132,3 22,3.44771525 22,4 C22,4.55228475 21.5075132,5 20.9,5 L1.1,5 C0.492486775,5 0,4.55228475 0,4 C0,3.44771525 0.492486775,3 1.1,3 Z M1.1,17 L20.9,17 C21.5075132,17 22,17.4477153 22,18 C22,18.5522847 21.5075132,19 20.9,19 L1.1,19 C0.492486775,19 0,18.5522847 0,18 C0,17.4477153 0.492486775,17 1.1,17 Z","fill":"currentColor"}));
}

IconActivity.defaultProps = {"width":"22px","height":"22px","viewBox":"0 0 22 22","version":"1.1"};

module.exports = IconActivity;

IconActivity.default = IconActivity;
